import NewTosConfirmation from './NewTosConfirmation';

export default NewTosConfirmation;